import { Token } from './Token';

export class TokenSequence {
  constructor(public tokens: Token[], public source: string) {}
}
